export default __webpack_public_path__ + "static/media/prologue-tv-negative.6ea0101c.png";